import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

const getUrl = `${LOGISTICE_GATEWAY}/website/index/cms/waybillTrail`

export function getData(params) {
  return logistice({
    url: getUrl,
    method: 'post',
    data: Object.assign(params, { methodName: 'findTrailByOrderNum' })
  })
}
